import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { UserClientMappingViewModel } from '../../viewmodels/user-client-mapping-viewmodel';

@Component({
  selector: 'app-user-client-mapping',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    InputTextModule,
    FluidModule,
    ButtonModule,
    SelectModule,
    TextareaModule,
    ToolbarModule,
    TableModule,
    InputIconModule,
    IconFieldModule,
    DialogModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule
  ],
  templateUrl: './user-client-mapping.component.html',
  styleUrls: ['./user-client-mapping.component.scss'],
  providers: [ConfirmationService, UserClientMappingViewModel]
})
export class UserClientMappingComponent implements OnInit {
  private router = inject(Router);
  viewModel = inject(UserClientMappingViewModel);

  @ViewChild('dt') table!: Table;

  ngOnInit(): void {
    // Check if returning from create page with new data
    // const navigation = this.router.getCurrentNavigation();
    // const state = navigation?.extras.state || history.state;

    // if (state?.newUserClient) {
    //   this.viewModel.addUserClient(state.newUserClient);
    // }
    this.viewModel.init();
  }
}
